import { defineNuxtPlugin } from '#app';
import { initializeApp } from 'firebase/app';
import { browserLocalPersistence, browserPopupRedirectResolver, browserSessionPersistence, indexedDBLocalPersistence, initializeAuth } from 'firebase/auth';

export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig();

  const firebaseConfig = {
    apiKey: runtimeConfig.public.FIREBASE_API_KEY,
    authDomain: runtimeConfig.public.FIREBASE_AUTH_DOMAIN,
    projectId: runtimeConfig.public.FIREBASE_PROJECT_ID,
    storageBucket: runtimeConfig.public.FIREBASE_STORAGE_BUCKET,
  };

  const app = initializeApp(firebaseConfig);

  // IndexedDB 永続化は hidden 中に DB を閉じてポップアップ認証の保存を落とすため、getAuth() 既定の階層から localStorage を先頭へ繰り上げる。残りは既存セッションの移送元として要る
  initializeAuth(app, {
    persistence: [browserLocalPersistence, indexedDBLocalPersistence, browserSessionPersistence],
    popupRedirectResolver: browserPopupRedirectResolver,
  });
});
